<template>
  <div id="app">
    <loading :isShow="showOrNot" />
    <page-kv :isShow="showOrNot" />
    <page-one :isShow="showOrNot" @sendImg="onSendImg" @sendFnImgHeight="onSFI" />
    <page-two :fnSrc="fnImgSrc" :isShow="showOrNot" :fnHeight="fnHeight" />
    <music-player :isShow="showOrNot" />
    <wx-share :shareTitle="title" :shareDesc="desc" :shareImg="thumbImg" :shareLink="link" />
    <rotate-it />
  </div>
</template>

<script>
import Rotate from './components/rotate/Rotate'
import MusicPlayer from './components/musicplayer/music-player'
import WxShare from './components/wxShare/wxShare';
import Loading from './pages/loading/loading'
import PageKV from './pages/page-kv/pageKV'
import PageOne from './pages/page-one/pageOne'
import PageTwo from './pages/page-two/pageTwo'

export default {
  name: 'app',
  components: {
    Loading,
    'rotate-it': Rotate,
    'music-player': MusicPlayer,
    'page-one': PageOne,
    'page-two': PageTwo,
    'page-kv': PageKV,
    'wx-share': WxShare
  },
  data () {
    return {
      title: '过年，怎么能少得了TA',
      desc: 'DIY专属自己的春联，让年味触达心底',
      thumbImg: 'https://www.jiandoukeji.com/h5/2019/baojie/wxshare/thumb.jpg',
      link: 'https://www.jiandoukeji.com/h5/2019/baojie/',
      fnImgSrc: null,
      fnHeight: null,
      showOrNot: {
        isLDShow: true,
        isKVShow: false,
        isPOShow: false,
        isPTShow: false,
      }
    }
  },
  methods: {
    onSendImg(msg) {
      this.fnImgSrc = msg;
    },
    onSFI(msg) {
      this.fnHeight = msg;
    }
  }
}
</script>

<style>
@import './assets/reset.less';
#app {
  position: fixed;
  width: 100%;
  max-width: 540px;
  min-width: 320px;
  height: 100%;
}

canvas {
  width: 100%;
}
</style>
